//
//
//
//
//
//

import RateItem from "@/components/rateItem.vue"; //评价
import {
    rateList
  } from "@/api/goodDetails"

export default {
   components:{
      RateItem
   },
   data() {
      return {
         rateItemList: []
      }
   },
   created() {
    if(this.$route.query.gid){
      this.getRateList(this.$route.query.gid)
    }
      
   },
    mounted() {

   },
    methods: {
      //获取商品评价
      getRateList(gid){
        let params = {
          gid: gid
        }
        rateList(params).then(res=>{
          this.rateItemList = res.data.map(item=>{
            if(item.picUrls){
              item.imgsList = item.picUrls.split(',')
            }
            return item
          })
        })
      }
   },
}



// WEBPACK FOOTER //
// ./src/view/goodsRate/goodsRate.vue